import React from "react";

import image1 from "../assets/services/1.png";
import image2 from "../assets/services/2.png";
import image3 from "../assets/services/3.png";
import image4 from "../assets/services/4.png";
import stats from "../assets/services/stats.svg";
import expertBanner from "../assets/services/experts-banner.jpg";
import graphOne from "../assets/services/graph-01.jpg";
import graphTwo from "../assets/services/graph-02.jpg";
import ServiceBlocks from "../components/Services/blocks";
import { motion, useScroll } from "framer-motion";

const sectionVariants = {
  offscreen: {
    y: -100, // Initially off-screen
    opacity: 0, // Hidden
  },
  onscreen: {
    y: 0, // Moves to its normal position
    opacity: 1, // Fade in
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.6, // Animation duration
    },
  },
};

const Services = () => {
  const { scrollY } = useScroll();

  console.log('scroll', scrollY);
  return (
    <>
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.8 }}
        className="flex flex-col items-center self-stretch px-5 pb-5 w-full bg-dark-indigo max-md:max-w-full">
        <div className="mt-9 text-2xl sm:text-4xl font-medium leading-10 text-center text-white capitalize w-[765px] max-md:max-w-full">
          Harness the power of expert insights
        </div>
        <div className="mt-5 text-lg text-center text-white w-full sm:w-[936px] max-md:max-w-full">
          Our network prioritizes quality and depth, serving as your gateway to
          unparalleled expertise. Utilize insights from our network to make
          informed decisions, gain a competitive advantage, and stay abreast of
          industry trends.
        </div>
        <div className="flex-wrap justify-center content-start mt-6 max-w-full w-[817px]">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col ml-1 w-3/12 max-md:ml-0 max-md:w-full">
              <motion.div
                variants={sectionVariants} 
                className="flex flex-col items-center grow py-0.5 text-lg font-medium text-center text-white capitalize max-md:mt-6"
              >
                <div className="flex items-center justify-center w-[84px] h-[84px] rounded-md shadow-3xl bg-white p-3">
                  <img
                    loading="lazy"
                    src={image1}
                    className="w-full h-full drop-shadow-xl"
                  />
                </div>
                <div className="mt-4">Access to top-tier expertise</div>
              </motion.div>
            </div>
            <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
              <motion.div
                variants={sectionVariants}  
                className="flex flex-col items-center grow py-0.5 text-lg font-medium text-center text-white capitalize max-md:mt-6"
                >
                <div className="flex items-center justify-center w-[84px] h-[84px] rounded-md shadow-3xl bg-white p-3">
                  <img
                    loading="lazy"
                    src={image2}
                    className="w-full h-full drop-shadow-xl"
                  />
                </div>
                <div className="mt-4">Customized & targeted research</div>
              </motion.div>
            </div>
            <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
              <motion.div className="flex flex-col items-center grow py-0.5 text-lg font-medium text-center text-white capitalize max-md:mt-6"
                variants={sectionVariants}
              >
                <div className="flex items-center justify-center w-[84px] h-[84px] rounded-md shadow-3xl bg-white p-4">
                  <img
                    loading="lazy"
                    src={image3}
                    className="w-full h-full drop-shadow-xl"
                  />
                </div>
                <div className="mt-4">
                  list of available experts for review in 24h
                </div>
              </motion.div>
            </div>
            <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
              <motion.div
                variants={sectionVariants}
                className="flex flex-col items-center grow py-0.5 text-lg font-medium text-center text-white capitalize max-md:mt-6">
                <div className="flex items-center justify-center w-[84px] h-[84px] rounded-md shadow-3xl bg-white p-3">
                  <img
                    loading="lazy"
                    src={image4}
                    className="w-full h-full drop-shadow-xl"
                  />
                </div>
                <div className="mt-4">Confidentiality & anonymity</div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      <ServiceBlocks />

      <motion.section className="flex justify-center items-center pb-16 mb-16 w-full max-md:px-5 max-md:mt-10 max-md:max-w-full"
      initial={{ opacity: 0, translateY: 100 }}
      whileInView={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 0.6, delay: 0.5, type: "spring" }}
      viewport={{ once: true }} >
        <div className="flex flex-col w-full max-w-[1120px] max-md:max-w-full mt-10">
          <div className="heading mx-auto relative">
             <img src={expertBanner} className="w-full sm:max-w-[400px] md:max-w-[936px]" alt="expert-network" />
             <h3 className="absolute top-[-2px] sm:top-[8px] left-1/2 tranform translate-x-[-50%] text-white font-medium text-[18px] md:text-[45px] mb-0 text-center leading-[45px] w-full">Our Expert Network <br className="inline md:block"/> Powered by 400k+ Experts! </h3>
          </div>

          <div className="content mt-5 max-w-[740px] mx-auto">
            <h3 className="text-center text-[#6369C4] text-[18px] md:text-[33px] font-medium">Our Network of Experts Across the Globe</h3>
            <ul className="list-none text-center text-[#363882] font-medium text-[20px] mt-4">
              <li>
                <span>•</span> Network coverage across all sectors and regions
              </li>
              <li>
                <span>•</span> Custom recruitment on each project
              </li>
              <li>
                <span>•</span> Dedicated teams for each account
              </li>
            </ul>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2">
             <motion.div className="flex flex-col items-center mb-2"
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} >
                <h3 className="p-2 rounded-md bg-[#363882] text-white text-center font-medium text-[21px] w-full max-w-[320px]">EXPERT BY SECTOR</h3>
                <img src={graphOne} className="w-full max-w-[500px] mt-10" alt="graph"/>
             </motion.div>

             <motion.div className="flex flex-col items-center mb-2"
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} >
                <h3 className="p-2 rounded-md bg-[#6369C4] text-white text-center font-medium text-[21px] w-full max-w-[320px] md:ml-[100px]">GLOBAL EXPERT FOOTPRINT</h3>
                <img src={graphTwo} className="w-full max-w-[430px] mt-10 md:mt-16 align-middle" alt="graph"/>
             </motion.div>
          </div>

        </div>
      </motion.section>
    </>
  );
};

export default Services;
